// src/pages/Pricing.js
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Container, Paper, Typography } from "@mui/material";

import Seo from "../components/Seo";
import { SITE } from "../data/site";
import { buildBreadcrumbSchema, buildOfferCatalogSchema, buildWebPageSchema } from "../utils/schema";
import "./Pricing.css";

export default function Pricing() {
  const title = "Pricing — Brainwave Solutions";
  const description =
    "Pricing starts at $50 and depends on the scope of the project. Get a free quote for spreadsheets, reporting, automation, websites, bookkeeping, and more.";
  const canonical = "https://brainwavesolutions.net/pricing";
  const structuredData = [
    buildWebPageSchema({ title, description, canonical }),
    buildOfferCatalogSchema(canonical),
    buildBreadcrumbSchema([
      { name: "Home", url: SITE.url },
      { name: "Pricing", url: canonical },
    ]),
  ];

  return (
    <>
      <Seo
        title={title}
        description={description}
        canonical={canonical}
        structuredData={structuredData}
      />

      <Box className="bws-pricingHero">
        <Container maxWidth="lg">
          <div className="bws-pricingHeroInner">
            <div>
              <Typography variant="h1" className="bws-pricingTitle">
                Pricing
              </Typography>

              <p className="bws-pricingLead">
                Pricing depends on the scope of the work, the level of complexity, and how much time the project will
                take. Some requests are quick fixes, while others involve larger builds, cleanup work, or ongoing
                support.
              </p>

              <p className="bws-pricingLead bws-pricingLeadSecondary">
                If you send a short description of what you need, I can review it and provide a free quote along with
                the best path forward.
              </p>

              <div className="bws-pricingTopCta">
                <Button component={RouterLink} to="/contact" variant="contained" className="bws-btn">
                  Request a quote
                </Button>
                <Button component={RouterLink} to="/services" variant="outlined" className="bws-btnGhost">
                  View services
                </Button>
              </div>
            </div>

            <Paper className="bws-pricingCard" elevation={0}>
              <div className="bws-pricingPill">Starting at</div>
              <div className="bws-pricingPrice">$50</div>
              <div className="bws-pricingText">
                Final pricing depends on the project type, scope, and timeline. One-time projects and ongoing support
                are both available.
              </div>

              <div className="bws-pricingDivider" />

              <ul className="bws-pricingList">
                <li>Quick fixes and larger projects welcome</li>
                <li>Businesses and individuals welcome</li>
                <li>Free quotes before work begins</li>
              </ul>

              <Button
                component={RouterLink}
                to="/contact"
                variant="contained"
                className="bws-btn bws-pricingBtn"
              >
                Request free quote
              </Button>
            </Paper>
          </div>

          <Paper className="bws-pricingBottomCta" elevation={0}>
            <div>
              <Typography className="bws-ctaTitle">Contact us for a FREE quote</Typography>
              <p className="bws-muted">
                Send a description of your project and what you would like assistance with. 
              </p>
            </div>
            <Button component={RouterLink} to="/contact" variant="contained" className="bws-btn">
              Contact
            </Button>
          </Paper>
        </Container>
      </Box>
    </>
  );
}
